import { render } from "./OrderPage.vue?vue&type=template&id=6b628860&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=6b628860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b628860"]])

export default __exports__